import { type AppThunkApiConfig, createAppAsyncThunk } from 'reduxTyped'
import { handleError } from 'shared/api/lib/errors/handlers'
import { AgencyApi } from 'shared/api/requests/agency'
import type {
  AgencyAchievements,
  AgencyBenefitsLinks,
  AgencyStatus,
} from 'shared/api/requests/agency/schemas'

const getRejectValue = (error: unknown): AppThunkApiConfig['rejectValue'] =>
  ((error as { response?: AppThunkApiConfig['rejectValue'] } | null)?.response ??
    error) as AppThunkApiConfig['rejectValue']

export const requestConnectPageToAgency = createAppAsyncThunk<Record<string, never>>(
  'agency/status/requestConnectPageToAgency',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await AgencyApi.requestConnectPageToAgency()

      return data
    } catch (error) {
      handleError(error)

      return rejectWithValue(getRejectValue(error))
    }
  },
)

export const getStatus = createAppAsyncThunk<AgencyStatus, number>(
  'agency/status/getStatus',
  async (agencyId, { rejectWithValue }) => {
    try {
      const { data } = await AgencyApi.getStatus({
        path: {
          agency_id: agencyId,
        },
      })

      return data
    } catch (error) {
      handleError(error)

      return rejectWithValue(getRejectValue(error))
    }
  },
)

export const getAchievements = createAppAsyncThunk<AgencyAchievements, number>(
  'agency/status/getAchievements',
  async (agencyId, { rejectWithValue }) => {
    try {
      const { data } = await AgencyApi.getAchievements({
        path: {
          agency_id: agencyId,
        },
      })

      return data
    } catch (error) {
      handleError(error)

      return rejectWithValue(getRejectValue(error))
    }
  },
)

export const getBenefitsLinks = createAppAsyncThunk<AgencyBenefitsLinks, number>(
  'agency/status/getBenefitsLinks',
  async (agencyId, { rejectWithValue }) => {
    try {
      const { data } = await AgencyApi.getBenefitsLinks({
        path: {
          agency_id: agencyId,
        },
      })

      return data
    } catch (error) {
      handleError(error)

      return rejectWithValue(getRejectValue(error))
    }
  },
)
